import { render, staticRenderFns } from "./statementManagementFinanceToReview.vue?vue&type=template&id=5067aeda&scoped=true"
import script from "./statementManagementFinanceToReview.vue?vue&type=script&lang=js"
export * from "./statementManagementFinanceToReview.vue?vue&type=script&lang=js"
import style0 from "./statementManagementFinanceToReview.vue?vue&type=style&index=0&id=5067aeda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067aeda",
  null
  
)

export default component.exports